import React, { useState } from 'react';
import './style.scss';
import useWs from '../../../../../contexts/websockets';
import useInitFight from '../../../../../contexts/initFight';
import Button from '../../../../controls/button';
import { useWsToHttp } from '../../../../../hooks/wsToHttp/useWsToHttp';
import useAlert from '../../../../../contexts/alert';

interface Props {
  children: React.ReactNode;
  isQueue?: boolean;
}

const WSExitWrapper = ({ children, isQueue }: Props) => {
  const alert = useAlert();
  const [loading, setLoading] = useState(false);
  const { wsDisconnect } = useWs();
  const { exitQueue } = useWsToHttp();
  const { goHome } = useInitFight();

  const handleClick = () => {
    if (!isQueue) {
      wsDisconnect();
      goHome();
      return;
    }
    setLoading(true);
    exitQueue()
      .then(() => {
        wsDisconnect();
        goHome();
      })
      .catch((err) => {
        alert.showError(err?.error || "Can't exit the queue");
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className='ws-exit-wrapper'>
      {children}
      <Button
        onClick={handleClick}
        color='default'
        variant='outlined'
        className='ws-exit-wrapper-button'
        loading={loading}
      >
        Exit
      </Button>
    </div>
  );
};

export default WSExitWrapper;
